import PropTypes from 'prop-types';
import cn from 'classnames';

// JSDoc type definitions
/**
 * @typedef LdsIconProps
 * @property {string} name - Name of the phosphor icon
 * @property {boolean} [inline] - Set the icon to `display: inline;`
 * @property {boolean} [decorative] - Add the `aria-hidden="true"` attribute to the icon
 * @property {string} [label] - Set a custom value to the `<title></title>` element of the icon `<svg>`; defaults to the icon name value; use on non-decorative icons
 * @property {string} [className] - Additional classes to add to the component
 */
/**
 * LdsIcon component
 * @param {LdsIconProps & React.InputHTMLAttributes<HTMLInputElement>} props
 * @returns {React.JSX.Element}
 */
export default function LdsIcon({
  name,
  inline = false,
  decorative,
  label,
  className,
  ...rest
}) {
  const pascalToKebab = (str) => {
    let iconName;

    try {
      iconName = str;
      iconName = iconName.replace(/([a-z0–9])([A-Z])/g, '$1-$2').toLowerCase();
    } catch (ex) {
      // eslint-disable-next-line no-console
      console.error(`LDS ERROR: Unexpected failure converting icon name '${str}' from pascalToKebab:`, ex.message);
      iconName = '!ERROR';
    }

    return iconName;
  };
  const iconName = pascalToKebab(name);

  return (
    <svg
      className={cn(
        'lds-icon',
        `${iconName}`,
        {
          inline,
        },
        className
      )}
      aria-hidden={decorative}
      role="img"
      focusable="false"
      {...rest}
    >
      <title>
        {label || iconName}
      </title>
    </svg>
  );
}

LdsIcon.propTypes = {
  name: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  decorative: PropTypes.bool,
  label: PropTypes.string,
};
